<template>
    <div class="pt-4 tb-4">
        <div class="display-1 mb-4">Измерение социально-эмоциональных характеристик (BIG5)</div>

        <v-layout v-if="!hideChart">
            <v-flex xs12 class="mr-4">
                <apex-charts class="shedule" width="800" type="bar" :options="options" :series="series"></apex-charts>
            </v-flex>
        </v-layout>

        <div>
            <div class="headline mb-3">{{extroversionData.title}}</div>
            <ul>
                <li v-for="(cat, i) in extroversionData.items" :key="i">{{cat}}</li>
            </ul>
        </div>

        <div class="mt-4">
            <div class="headline mb-3">{{attachmentData.title}}</div>
            <ul>
                <li v-for="(cat, i) in attachmentData.items" :key="i">{{cat}}</li>
            </ul>
        </div>

        <div class="mt-4">
            <div class="headline mb-3">{{goodwiseData.title}}</div>
            <ul>
                <li v-for="(cat, i) in goodwiseData.items" :key="i">{{cat}}</li>
            </ul>
        </div>

        <div class="mt-4">
            <div class="headline mb-3">{{emotionalityData.title}}</div>
            <ul>
                <li v-for="(cat, i) in emotionalityData.items" :key="i">{{cat}}</li>
            </ul>
        </div>

        <div class="mt-4">
            <div class="headline mb-3">{{opennessData.title}}</div>
            <ul>
                <li v-for="(cat, i) in opennessData.items" :key="i">{{cat}}</li>
            </ul>
        </div>


    </div>
</template>
<script>
    import ApexCharts from 'vue-apexcharts'
    import data from './data'

    export default {
        props: {
            value: Object,
            hideChart: Boolean
        },
        components: {
            ApexCharts
        },
        computed: {
            extroversionLevel () {
                if (this.value.extroversion > 3.66) return 4
                else if (this.value.extroversion >= 2.5) return 3
                else if (this.value.extroversion >= 1.8) return 2
                else return 1
            },
            extroversionData () {
                return data['extroversion']['level' + this.extroversionLevel]
            },
            attachmentLevel () {
                if (this.value.agreeableness > 3.66) return 4
                else if (this.value.agreeableness >= 2.5) return 3
                else if (this.value.agreeableness >= 1.8) return 2
                else return 1
            },
            attachmentData () {
                return data['attachment']['level' + this.attachmentLevel]
            },
            goodwiseLevel () {
                if (this.value.conscientiousness > 2.5) return 2
                else return 1
            },
            goodwiseData () {
                return data['goodwise']['level' + this.goodwiseLevel]
            },
            emotionalityLevel () {
                if (this.value.agreeableness > 3.66) return 4
                else if (this.value.agreeableness >= 2.5) return 3
                else if (this.value.agreeableness >= 1.8) return 2
                else return 1
            },
            emotionalityData () {
                return data['emotionality']['level' + this.emotionalityLevel]
            },
            opennessLevel () {
                if (this.value.conscientiousness > 2.5) return 2
                else return 1
            },
            opennessData () {
                return data['openness']['level' + this.opennessLevel]
            },

            series () {
                return [{
                    data: [this.value.extroversion, this.value.agreeableness, this.value.conscientiousness, this.value.negative_emotionality, this.value.open_mindedness].map(item => Number(item).toPrecision(2))
                }]
            },
            options () {
                return {
                    labels: [
                        'Экстраверсия',
                        'Привязанность',
                        'Добросовестность',
                        'Эмоциональность',
                        'Открытость новому'
                    ],
                    dataLabels: {
                        enabled: true,
                    },
                    tooltip: {
                        enabled: false,
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            endingShape: 'flat',
                            distributed: false
                        }
                    }
                }
            }
        }
    }
</script>
<style scoped lang="stylus">
    .shedule {
        /deep/ .apexcharts-canvas {
            margin: 0 auto;
        }
        /deep/ .apexcharts-toolbar {
            display none
        }
    }
</style>
